module.exports = __webpack_public_path__ + "static/img/layer-char-1.9056f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/layer-char-1.png
// module id = RwA+
// module chunks = 1